import React from 'react';
import styled from 'styled-components';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { InnerSection, Section } from '../styles/section/section';
import Chat from '../components/search/components/no-results/chat';
import Support from '../components/search/components/no-results/support';
import { useAnalytics } from '../utils/analytics-provider/analytics-provider';

const NotFoundPageInnerSection = styled(InnerSection)`
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

export const Error = () => {
  return (
    <Section>
      <NotFoundPageInnerSection>
        <h3>
          Sorry, we don't have an answer for that. Ask your question in chat and we can help you
          out!
        </h3>

        <br />

        <Wrapper>
          <Chat />
          <Support />
        </Wrapper>
      </NotFoundPageInnerSection>
    </Section>
  );
};

const NotFoundPage = () => {
  const { trackEvent } = useAnalytics();
  trackEvent('page_hit', { page_hit: '404_not_found' });

  return (
    <Layout>
      <SEO title="404: Not found" />

      <Error />
    </Layout>
  );
};

export default NotFoundPage;
